import React, { useState } from 'react';
import { supabase } from '../../../lib/supabase';

const SMSOptinSection = () => {
  const [phone, setPhone] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const validatePhone = (val) => {
    return /^[\+]?[\d\s\-\(\)]{7,15}$/?.test(val?.trim());
  };

  const handleSubscribe = async (e) => {
    e?.preventDefault();
    if (!phone?.trim() || !validatePhone(phone)) {
      setError('Skriv inn et gyldig telefonnummer.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const { error: dbError } = await supabase?.from('contact_optins')?.insert({ phone: phone?.trim(), optin_sms: true, source: 'sms_section' });
      if (dbError) throw dbError;
    } catch (err) {
      console.error('SMS subscription error:', err);
    } finally {
      setLoading(false);
      setSubscribed(true);
    }
  };

  return (
    <section style={{
      background: '#050A12',
      padding: '100px 5%',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid rgba(255,255,255,0.06)'
    }}>
      {/* Ghost number */}
      <div style={{
        position: 'absolute', top: '-40px', left: '-20px',
        fontFamily: 'Impact, Arial Black, sans-serif',
        fontSize: 'clamp(180px, 25vw, 320px)',
        fontWeight: 900, color: 'rgba(232,148,26,0.03)',
        lineHeight: 1, userSelect: 'none', pointerEvents: 'none',
        letterSpacing: '-0.05em'
      }}>02</div>
      {/* Diagonal accent */}
      <div style={{
        position: 'absolute', top: 0, right: '35%', width: '1px',
        height: '100%', background: 'rgba(59,111,212,0.07)',
        transform: 'rotate(-6deg)', transformOrigin: 'top center',
        pointerEvents: 'none'
      }} />
      <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1.2fr 1fr',
          gap: '80px',
          alignItems: 'center'
        }}>
          {/* Form panel */}
          <div style={{
            background: 'rgba(255,255,255,0.02)',
            border: '1px solid rgba(255,255,255,0.07)',
            padding: '48px',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, height: '3px',
              background: 'linear-gradient(90deg, #E8941A, #3B6FD4)'
            }} />

            {subscribed ? (
              <div style={{ textAlign: 'center', padding: '32px 0' }}>
                <div style={{
                  display: 'inline-block',
                  border: '3px solid #E8941A',
                  padding: '16px 32px',
                  transform: 'rotate(2deg)',
                  marginBottom: '24px'
                }}>
                  <div style={{
                    fontFamily: 'Impact, Arial Black, sans-serif',
                    fontSize: '1.4rem', color: '#E8941A',
                    letterSpacing: '0.15em', textTransform: 'uppercase'
                  }}>REGISTRERT</div>
                </div>
                <p style={{
                  fontFamily: 'Georgia, serif', fontStyle: 'italic',
                  fontSize: '1rem', color: 'rgba(238,240,242,0.6)',
                  lineHeight: 1.6
                }}>
                  Takk! Du vil motta SMS-varsler fra NordPass.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubscribe}>
                <div style={{ marginBottom: '28px' }}>
                  <label style={{
                    display: 'block',
                    fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
                    color: 'rgba(238,240,242,0.4)', letterSpacing: '0.2em',
                    textTransform: 'uppercase', marginBottom: '10px'
                  }}>MOBILNUMMER</label>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => { setPhone(e?.target?.value); setError(''); }}
                    placeholder="+47 000 00 000"
                    style={{
                      width: '100%', background: 'rgba(255,255,255,0.04)',
                      border: error ? '1px solid #E8941A' : '1px solid rgba(255,255,255,0.1)',
                      padding: '14px 18px',
                      fontFamily: 'Inter, sans-serif', fontSize: '0.95rem',
                      color: '#EEF0F2', outline: 'none',
                      boxSizing: 'border-box',
                      transition: 'border-color 0.2s'
                    }}
                  />
                  {error && (
                    <div style={{
                      fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
                      color: '#E8941A', marginTop: '6px', letterSpacing: '0.05em'
                    }}>{error}</div>
                  )}
                </div>

                <p style={{
                  fontFamily: 'Georgia, serif', fontStyle: 'italic',
                  fontSize: '0.78rem', color: 'rgba(238,240,242,0.35)',
                  lineHeight: 1.5, marginBottom: '24px'
                }}>
                  Ved a registrere deg samtykker du til a motta SMS-markedsforing fra NordPass. Standard meldingstakster kan gjelde.
                </p>

                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: '100%',
                    background: loading ? 'rgba(232,148,26,0.4)' : '#E8941A',
                    border: 'none',
                    padding: '16px 32px',
                    fontFamily: 'Syne, sans-serif', fontSize: '0.8rem',
                    fontWeight: 700, color: '#050A12',
                    letterSpacing: '0.12em', textTransform: 'uppercase',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => { if (!loading) e.target.style.background = '#d4820f'; }}
                  onMouseLeave={(e) => { if (!loading) e.target.style.background = '#E8941A'; }}
                >
                  {loading ? 'Registrerer...' : 'MELD DEG PA SMS →'}
                </button>
              </form>
            )}
          </div>

          {/* Text panel */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
              <div style={{ width: '40px', height: '1px', background: '#E8941A' }} />
              <span style={{
                fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
                color: '#E8941A', letterSpacing: '0.25em', textTransform: 'uppercase'
              }}>SMS-VARSLER</span>
            </div>

            <h2 style={{
              fontFamily: 'Impact, Arial Black, sans-serif',
              fontSize: 'clamp(42px, 6vw, 80px)',
              fontWeight: 900, color: '#EEF0F2',
              lineHeight: 0.9, letterSpacing: '-0.03em',
              textTransform: 'uppercase', margin: '0 0 8px'
            }}>FA VARSLER</h2>
            <h2 style={{
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: 'clamp(36px, 5vw, 68px)',
              fontWeight: 700, color: '#E8941A',
              lineHeight: 0.95, letterSpacing: '-0.02em',
              margin: '0 0 32px'
            }}>pa SMS.</h2>

            <p style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: '1.05rem', color: 'rgba(238,240,242,0.55)',
              lineHeight: 1.7, maxWidth: '380px', margin: '0 0 24px'
            }}>
              Motta umiddelbare SMS-varsler om vegarbeid, bomstasjonsendringer og eksklusive NordPass-tilbud direkte pa telefonen.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {['Sanntidsvarsler om vegarbeid', 'Eksklusive SMS-tilbud', 'Bomstasjonsoppdateringer']?.map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{
                    width: '6px', height: '6px',
                    background: '#E8941A',
                    transform: 'rotate(45deg)',
                    flexShrink: 0
                  }} />
                  <span style={{
                    fontFamily: 'JetBrains Mono, monospace', fontSize: '0.75rem',
                    color: 'rgba(238,240,242,0.5)', letterSpacing: '0.05em'
                  }}>{item}</span>
                </div>
              ))}
            </div>

            <div style={{
              display: 'inline-block',
              background: 'rgba(232,148,26,0.08)',
              border: '1px solid rgba(232,148,26,0.2)',
              padding: '6px 14px',
              transform: 'rotate(1.5deg)',
              marginTop: '24px',
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: '0.75rem', color: 'rgba(232,148,26,0.7)',
              letterSpacing: '0.03em'
            }}>
              Meld deg av nar som helst.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SMSOptinSection;
